import {
  GetClasseWithNoteAndStudentsOrdersQuery,
  Enum_Commande_Status
} from '../../../graphql/generated/graphql';
import { getElevesCommandesStatusFromQueryOng } from '../user';

export const getNgoInformationsFromQuery: (
  data: GetClasseWithNoteAndStudentsOrdersQuery
) => any = data => {
  return {
    studentsClass: {
      ngo: data.getClasseWithNoteAndEleves.ong,
      caClass: data.getClasseWithNoteAndEleves.noteclasse.qteca,
      percentDedicatedToNgo:
        data.getClasseWithNoteAndEleves.percentDedicatedToOng,
      orders: getElevesCommandesStatusFromQueryOng(
        data.getClasseWithNoteAndEleves.users
      )
    },
    student: {
      note: data.getMyNoteInClasse.note.attributes,
      ordersWithContribution: data.getMyOrdersInClasse.commandes.filter(
        commande =>
          commande.attributes.customerContributedToTheOng === true &&
          commande.attributes.status === Enum_Commande_Status.Paye
      ),
      orders: data.getMyOrdersInClasse.commandes,
      ngo: data.usersPermissionsUser.data.attributes.ong
    }
  };
};
